export const HasRouteChangeListenerMixin = {
  methods: {
    onRouteChange() {
      //
    }
  },
  watch: {
    $route(newRoute, oldRoute) {
      if (newRoute.name === oldRoute.name) {
        return;
      }

      this.onRouteChange();
    }
  }
};
